'use client';

import React, { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { usePathname } from '@/navigation';
import { COOKIE_CITY } from '@/shared/config/common/constants/storage';
import { getCookie } from '@/shared/lib/api/getCookie';
import { GTMContext } from '../model/context/GTMContext';
import { GTMParamsManager } from '../model/manager';
interface Props {
  children: React.ReactNode;
  headers: {
    cookie: string;
    setCookie: string;
  };
}
export const GTMProvider: React.FC<Props> = ({
  children,
  headers
}) => {
  const gtm = GTMParamsManager.getInstance();
  const pathname = usePathname();
  const locale = useLocale();
  const city = getCookie(COOKIE_CITY, headers.setCookie, 'set-cookie') || getCookie(COOKIE_CITY, headers.cookie, 'cookie') || 'city';
  useEffect(() => {
    gtm.setDefaultParams({
      locale,
      city,
      pageType: pathname
    });
  }, [pathname, locale, city]);
  return <GTMContext.Provider value={gtm} data-sentry-element="unknown" data-sentry-component="GTMProvider" data-sentry-source-file="GTMProvider.tsx">{children}</GTMContext.Provider>;
};